import { SupportedChainId } from './chainIds'
import { AddressMap } from './types'

/**
 * The latest Maia governor bravo
 */
export const GOVERNANCE_BRAVO_ADDRESSES: AddressMap = {
  [SupportedChainId.ARBITRUM_ONE]: '0xaA8D7127fFb6a9786529F15977003A2D469B2d95',
  [SupportedChainId.SEPOLIA]: '0x61B046e0812CF9c170fa09b9834708F73421B59b',
}

/**
 * The latest hermes governor bravo for severity 1 governance proposals
 */
export const GOVERNANCE_BRAVO_SEVERITY_1_ADDRESSES: AddressMap = {
  [SupportedChainId.ARBITRUM_ONE]: '0xEdf6aD5f569485090ECa00359E3e3813Be985809',
  [SupportedChainId.SEPOLIA]: '0x28a9ffd6Fe4497f0788606F64Ab7095fDeCe4Ebb',
}

/**
 * The latest hermes governor bravo for severity 2 governance proposals
 */
export const GOVERNANCE_BRAVO_SEVERITY_2_ADDRESSES: AddressMap = {
  [SupportedChainId.ARBITRUM_ONE]: '0xF2831E87088f2E113050c4EE5EB138978eAEBb49',
  [SupportedChainId.SEPOLIA]: '0x38bAd91B4c7016f8a9C71aab1071769Ec0FBe241',
}

/**
 * The latest hermes governor bravo for severity 3 governance proposals
 */
export const GOVERNANCE_BRAVO_SEVERITY_3_ADDRESSES: AddressMap = {
  [SupportedChainId.ARBITRUM_ONE]: '0x428f076301026c7665F7F70EEBbB391506aEc2a1',
  [SupportedChainId.SEPOLIA]: '0x8d2c9aA2e899B18e03931ccFcf088be0b3a23BdE',
}

/**
 * The latest hermes governor bravo for severity 4 governance proposals
 */
export const GOVERNANCE_BRAVO_SEVERITY_4_ADDRESSES: AddressMap = {
  [SupportedChainId.ARBITRUM_ONE]: '0x45E8089C4C033cb28bb652a153dDE49182Bae49a',
  [SupportedChainId.SEPOLIA]: '0xB9618958c953D67E15Bf7eFe78478Dd1e8b23CeC',
}

/**
 * The latest hermes governor bravo for severity 5 governance proposals
 */
export const GOVERNANCE_BRAVO_SEVERITY_5_ADDRESSES: AddressMap = {
  [SupportedChainId.ARBITRUM_ONE]: '0xb23c7BE6c14a145a7ca33083Fb6e8B3fC9c820aC',
  [SupportedChainId.SEPOLIA]: '0xBFFc42560a51832daa466955f39D81915402Fd50',
}

/**
 * The latest maia governor bravo for governance proposals
 */
export const TIMELOCK_ADDRESS: AddressMap = {
  [SupportedChainId.ARBITRUM_ONE]: '0x744f3EC772AAA9f0d40398b90F9E856EF88D118A',
  [SupportedChainId.SEPOLIA]: '0x86712f780F8883482e7EBf6f395CEe374CC59787',
}

/**
 * The latest hermes governor bravo for severity 1 governance proposals
 */
export const TIMELOCK_SEVERITY_1_ADDRESSES: AddressMap = {
  [SupportedChainId.ARBITRUM_ONE]: '0x07D87055E82EAf4851Dfa251a5d79A7E99Bd789A',
  [SupportedChainId.SEPOLIA]: '0x16DfceFF2e21c54Cd4B262edDCc1baEB734a112A',
}

/**
 * The latest hermes governor bravo for severity 2 governance proposals
 */
export const TIMELOCK_SEVERITY_2_ADDRESSES: AddressMap = {
  [SupportedChainId.ARBITRUM_ONE]: '0xb97c3D79Af827c915E5F6B492e6bd99D653F8cC7',
  [SupportedChainId.SEPOLIA]: '0x0d5783E0e19bf09A923A742E5feB0653c2Eed638',
}

/**
 * The latest hermes governor bravo for severity 3 governance proposals
 */
export const TIMELOCK_SEVERITY_3_ADDRESSES: AddressMap = {
  [SupportedChainId.ARBITRUM_ONE]: '0xaCE7B2BbD13acE4E23F622209c46C9F2885edd49',
  [SupportedChainId.SEPOLIA]: '0x69ff16440052DE228a158517d91E92D803e072D7',
}

/**
 * The latest hermes governor bravo for severity 4 governance proposals
 */
export const TIMELOCK_SEVERITY_4_ADDRESSES: AddressMap = {
  [SupportedChainId.ARBITRUM_ONE]: '0x716147a2169246c09f47D9880Bf85D49093A92C4',
  [SupportedChainId.SEPOLIA]: '0x8e0881066dA3B81041105B58303a975bD507091C',
}

/**
 * The latest hermes governor bravo for severity 5 governance proposals
 */
export const TIMELOCK_SEVERITY_5_ADDRESSES: AddressMap = {
  [SupportedChainId.ARBITRUM_ONE]: '0xB4523B4541Ab27337AB8389188a545BF3d07d5E3',
  [SupportedChainId.SEPOLIA]: '0x9de0F9B4a94a2119789F03A21Da42576114A0554',
}
